import * as React from 'react';

import { cn } from './utils';
import type { ButtonVariantProps } from './button-variants';
import { buttonVariants } from './button-variants';
import { Slot } from '@radix-ui/react-slot';

const Button = React.forwardRef<
  HTMLButtonElement,
  React.ComponentProps<'button'> &
    ButtonVariantProps & {
      asChild?: boolean;
    }
>(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : 'button';

  return (
    <Comp
      data-slot="button"
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props}
    />
  );
});

Button.displayName = 'Button';

export { Button };
